import React, { useEffect, useState } from "react";
import "./EducationTwoAboutUs.scss";

const EducationTwoAboutUs = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 767;

  return (
    <section className="et_aboutus education_two_sect_padding ">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column - Image Section (Hidden on mobile) */}
          {!isMobile && (
            <div className="col-lg-6">
              <div className="eta_left">
                <img
                  src="./assets/img/educationtwo/about_main_img.jpg"
                  alt="About Us"
                  className="main_img"
                />
                <img
                  src="./assets/img/educationtwo/about_img_top.jpg"
                  alt=""
                  className="img_top"
                />
                <img
                  src="./assets/img/educationtwo/about_img_bottom.jpg"
                  alt=""
                  className="img_bottom"
                />
                <img
                  src="./assets/img/educationtwo/about_shape.png"
                  alt=""
                  className="shape_img"
                />
              </div>
            </div>
          )}

          {/* Right Column - Content Section */}
          <div className={`col-lg-6 ${isMobile ? "col-12" : ""}`}>
            <div className="eta_right">
              {/* Section Header */}
              <div className="sect_header">
                <span className="sect_badge">Our about us</span>
                <h3 className="sect_title">
                  Learn & Grow your{" "}
                  <span className="relative">
                    skills
                    <span className="title-shape">
                      {/* SVG remains unchanged */}
                    </span>
                  </span>{" "}
                  From anywhere
                </h3>
              </div>

              {/* Description */}
              <p className="theme_description">
                Our mission is to list the Best Tutors, Tuition Centers, and Kids
                Events and Classes. Tutortot is an Education City.
              </p>

              {/* Info Cards (Stacked on mobile) */}
              <div className="more_info">
                <div className="info_card">
                  <h5>Exceptional tutors</h5>
                  <p className="theme_description">
                    Exceptional tutors. We only accept the best from thousands
                    of applicants, so you can choose from the widest range of
                    qualified experts.
                  </p>
                </div>
                <div className="info_card">
                  <h5>Variety of Subjects</h5>
                  <p className="theme_description">
                    PreSchool, Nursery, Kindergarten. Algebra, Calculus, and
                    Statistics to English, Chemistry, and Physics. You name it,
                    we list them.
                  </p>
                </div>
              </div>

              {/* Button */}
              <div className="theme_btn btn_fill with_icon">
                More About Us
                <span className="material-symbols-outlined">arrow_right_alt</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationTwoAboutUs;